<template>
	<transition name="modal">
		<div class="modal-mask">
			<div class="modal-wrapper" @click="$emit('closeModal')">
				<div class="row">
					<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
					<div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
						<div class="modal-container" @click.stop>

						<div class="modal-header row" style="justify-content: flex-end;">
							<div class="col">
								<button type="button" class="close" @click="$emit('closeModal')">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
						</div>
						<!-- Start Modal Body -->
						<div class="modal-body" style="min-height:50vh;">
                            <h3>Konfirmasi Perubahan Stok Pada System</h3>
                            <div class="row mt-4 text-left">
                                <div class="col-4 middleDiv">
                                    <h5>Penerima Barang</h5>
                                </div>
                                <div class="col-2 middleDiv">
                                    <h5>:</h5>
                                </div>
                                <div class="col-6">
                                    <MultiSelect
                                        :options="labourerList.map(x => x.id)"
                                        :custom-label="opt => labourerList.find(x => x.id == opt).name"
                                        v-model="labourer_id"
                                        class="w-100"
                                        placeholder="Pilih Pekerja"
                                    />
                                </div>
                            </div>

                            <div class="row mt-4 text-left">
                                <div class="col-4 middleDiv">
                                    <h5>Pilih Supplier</h5>
                                </div>
                                <div class="col-2 middleDiv">
                                    <h5>:</h5>
                                </div>
                                <div class="col-6">
                                    <MultiSelect
                                        :options="supplierList.map(x => x.id)"
                                        :custom-label="opt => supplierList.find(x => x.id == opt).name"
                                        v-model="supplier_id"
                                        class="w-100"
                                        placeholder="Pilih Supplier"
                                    />
                                </div>
                            </div>
                            
                            <div class="mt-3" style="max-height:350px;overflow-y:scroll">
                                <table class="table table-bordered">
                                    <thead class="thead-dark">
                                        <th>No.</th>
                                        <th>Nama Sparepart</th>
                                        <th>Stok Lama</th>
                                        <th>Stok Baru</th>
                                        <th>Perubahan Stok</th>
                                    </thead>
                                    <tbody v-for="(sparepart , index) in stockChange" :key="sparepart.sparepart_name + index">
                                        <tr>
                                            <td>{{index + 1}}.</td>
                                            <td>{{sparepart.sparepart_name}}</td>
                                            <td>{{parseFloat(sparepart.stocks ? sparepart.stocks : 0)}}</td>
                                            <td>{{parseFloat(sparepart.new_stock)}}</td>
                                            <td>{{parseFloat(sparepart.change_stock)}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <button :disabled="apiLoading" @click="approved" class="btn btn-success w-100">
                                        <span class="spinner-grow spinner-grow-sm" v-if="apiLoading"></span> Konfirmasi Perubahan Stok
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button @click="$emit('closeModal')" class="btn btn-danger w-100">Batal</button>
                                </div>
                            </div>
						</div>
						<!-- End Modal Body -->
					</div>
				</div>
			</div>
			<div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
		</div>
  </div>

 
</transition>
</template>

<script>
import MultiSelect from 'vue-multiselect'
export default {
	components : {
		MultiSelect
	},
    props : ['stockChange' , 'labourerList' , 'supplierList', 'apiLoading'],
	data () {
        return {
            supplier_id : null,
            labourer_id : null
        }
  	},
  	watch : {

	},
	mounted () {
	},
	methods : {
		approved () {
            if(!this.labourer_id) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Isi Representative Pekerja'])
				return
			}
			if(!this.supplier_id) {
				this.$store.dispatch('triggerAlert' , [false , 'Mohon Isi Supplier'])
				return
			}

            this.$emit('approved' , this.supplier_id , this.labourer_id)
        }
	},
}
</script>

<style scoped>
	.input--style-4:disabled {
		/* Mozilla Firefox 4 to 18 */
		color: white !important;
	}
</style>

<style>

td {
	vertical-align: middle !important;
}

/* ==========================================================================
#form made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}
c

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding:20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 35px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}


/* FILE DRAG N' DROP START */
.dropZone {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone:hover {
  border: 2px solid #2e94c4;
}

.dropZone:hover .dropZone-title {
  color: #1975A0;
}

.dropZone-info {
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.dropZone-title {
  color: #787878;
}

.dropZone input {
  position: absolute;
  cursor: pointer;
  top: 0px;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
}

.dropZone-upload-limit-info {
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}

.dropZone-over {
  background: #5C5C5C;
  opacity: 0.8;
}

.dropZone-uploaded {
  /* width: 80%; */
  height: 200px;
  position: relative;
  border: 2px dashed #eee;
}

.dropZone-uploaded-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #A8A8A8;
  position: absolute;
  top: 50%;
  width: 100%;
  transform: translate(0, -50%);
  text-align: center;
}

.removeFile {
  width: 200px;
}
/* FILE DRAG N' DROP END */


</style>
